// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';

import AnimatedDigitsLabel from '../../../components/AnimatedDigitsLabel';
import { usePrevious } from '../../../hooks';
import MPCardProgressSvgAsComponent from '../assets/svg/asComponent/MPCardsProgressSvgAsComponent';

const DIGITS_TRANSITION_DURATION = 1000; // ms

const Wrapper = styled.div`
  min-width: 7.5em;
`;

const RelativeContent = styled.div`
  position: relative;
`;

const CardIcons = styled(MPCardProgressSvgAsComponent)`
  position: absolute;
  height: 3em;
  width: 3em;
  right: 0;
  top: 0;

  z-index: 1;

  transform: translate(40%, -0.9em);
`;

const ProgressBar = styled.div`
  padding: 0.2em 0.2em 0.1em;

  background-image: linear-gradient(to right, #079f1f 0%, #079f1f 50%, #353b4e 50%, #353b4e 100%);
  background-size: 200%;
  transition: background-position ${DIGITS_TRANSITION_DURATION}ms ease-in-out;
  border-radius: 0.6em;
  border: 0.1em solid black;
  border-bottom: 0.2em solid black;

  font-family: 'KabelHasbro';
  font-size: 1.2em;
  text-align: center;
  color: white;
  text-shadow: 0px 1px 1px black;

  ${({ $progressPercent }) => css`
    background-position: ${100 - $progressPercent}%;
  `};
`;

const StyledAnimatedDigitsLabel = styled(AnimatedDigitsLabel)`
  font-weight: normal;
`;

type MPBannerUserProgressProps = {
  className?: string;
  userNbWonCards: number;
  totalNbCards: number;
};

const MPBannerUserProgress = ({ className = '', userNbWonCards = 0, totalNbCards = 0 }: MPBannerUserProgressProps) => {
  const previousNbWonCards = usePrevious(userNbWonCards);
  const progressPercent = useMemo(
    () => Math.max(Math.min(userNbWonCards / totalNbCards, 1), 0) * 100,
    [totalNbCards, userNbWonCards],
  );

  const formatDigits = useCallback((n: number) => `${Math.floor(n)} / ${totalNbCards}`, [totalNbCards]);

  return (
    <Wrapper className={className}>
      <RelativeContent>
        <ProgressBar $progressPercent={progressPercent}>
          <StyledAnimatedDigitsLabel
            current={previousNbWonCards}
            next={userNbWonCards}
            formatFn={formatDigits}
            lastFormatFn={formatDigits}
            timeout={DIGITS_TRANSITION_DURATION}
          />
        </ProgressBar>
        <CardIcons />
      </RelativeContent>
    </Wrapper>
  );
};

export default MPBannerUserProgress;
